import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import VirtualTourModal from "./VirtualTourModal";
import TourRequestModal from "./TourRequestModal";

const TourContext = createContext({ openVideo: () => {}, openRequest: () => {} });

export const useTour = () => useContext(TourContext);

// Lets any button on any page open the virtual tour video or the "Schedule a Tour" form.
export function TourProvider({ children }) {
  const [openModal, setOpenModal] = useState(null); // "video" | "request" | null

  const close = useCallback(() => setOpenModal(null), []);
  const value = useMemo(
    () => ({
      openVideo: () => setOpenModal("video"),
      openRequest: () => setOpenModal("request"),
    }),
    []
  );

  return (
    <TourContext.Provider value={value}>
      {children}
      {openModal === "video" && <VirtualTourModal onClose={close} />}
      {openModal === "request" && <TourRequestModal onClose={close} />}
    </TourContext.Provider>
  );
}
